import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RegionMapResponse } from '../../types/dashboard';
import { SelectedFilters } from '../../types/filters';

interface RegionMapState {
  data: RegionMapResponse | null;
  loading: boolean;
  error: string | null;
}

const initialState: RegionMapState = {
  data: null,
  loading: false,
  error: null
};

const regionMapSlice = createSlice({
  name: 'regionMap',
  initialState,
  reducers: {
    fetchRegionMapStart: (state, action: PayloadAction<SelectedFilters | undefined>) => {
      state.loading = true;
      state.error = null;
    },
    fetchRegionMapSuccess: (state, action: PayloadAction<RegionMapResponse>) => {
      state.loading = false;
      state.data = action.payload;
    },
    fetchRegionMapFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    }
  }
});

export const { fetchRegionMapStart, fetchRegionMapSuccess, fetchRegionMapFailure } = regionMapSlice.actions;
export default regionMapSlice.reducer; 